import { render, staticRenderFns } from "./BrowseSidebar.vue?vue&type=template&id=272f4fc6&scoped=true"
import script from "./BrowseSidebar.vue?vue&type=script&lang=ts"
export * from "./BrowseSidebar.vue?vue&type=script&lang=ts"
import style0 from "./BrowseSidebar.vue?vue&type=style&index=0&id=272f4fc6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f4fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272f4fc6')) {
      api.createRecord('272f4fc6', component.options)
    } else {
      api.reload('272f4fc6', component.options)
    }
    module.hot.accept("./BrowseSidebar.vue?vue&type=template&id=272f4fc6&scoped=true", function () {
      api.rerender('272f4fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseSidebar.vue"
export default component.exports